<template>
  <Wrapper>
    <el-page-header
      title="单关键词趋势分析"
      content="近10周趋势对比 · 自己店铺 vs Top10平均"
    />
    <SingleTopKeyword
      :initial-keyword="route.query.keyword"
      :initial-shop-code="route.query.shop_code || 'lotov'"
    />
  </Wrapper>
</template>

<script setup>
import { useRoute } from 'vue-router'
import { onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'
import Wrapper from '@/components/Wrapper.vue'
import SingleTopKeyword from '@/components/SingleTopKeyword.vue'

const route = useRoute()
const authStore = useAuthStore()

onMounted(async () => {
  await authStore.initAuth()
})
</script>